var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMyAccountBets(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_22108",
    "data-name": "Group 22108",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15.92,
    height: 20.988,
    viewBox: "0 0 15.92 20.988",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9348",
    "data-name": "Rectangle 9348",
    width: 15.92,
    height: 20.988,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22108-2",
    "data-name": "Group 22108",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16120",
    "data-name": "Path 16120",
    d: "M47.871,19.567c0-.1.008-.191.008-.287q0-7.921,0-15.843c0-.1,0-.191.007-.287a.541.541,0,0,1,.34-.07h2.034a2.4,2.4,0,0,0,.265-.007c.269-.03.381-.145.383-.416.005-.7,0-1.4,0-2.1a3.579,3.579,0,0,1,.026-.505c.065-.074.152-.043.229-.043C54.742.007,58.32.012,61.9,0a.858.858,0,0,1,.819.824q-.015,9.316-.007,18.632c0,.366-.1.469-.474.469l-1.084,0a.39.39,0,0,1-.294.067q-6.239,0-12.479,0a.788.788,0,0,1-.284-.037.318.318,0,0,1-.224-.391",
    transform: "translate(-46.797 0)",
    fill: "#ededed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16122",
    "data-name": "Path 16122",
    d: "M51.391,1.057c.073.065.042.152.043.229q0,1.194,0,2.388c0,.326-.149.479-.484.48-.87,0-1.739,0-2.609,0a2.99,2.99,0,0,1,.475-.51c.3-.306.6-.6.9-.9.049-.05.125-.086.117-.175a.368.368,0,0,0,.118-.052q.722-.726,1.439-1.456",
    transform: "translate(-47.251 -1.005)",
    fill: "#e5e4e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16123",
    "data-name": "Path 16123",
    d: "M78.012,104.117h5.753c.36,0,.506.145.506.51q0,5.731,0,11.463c0,.365-.146.51-.507.51H80.844c-.346,0-.5-.142-.508-.492-.008-.28-.015-.561,0-.841.013-.208-.088-.219-.251-.219q-3.319.006-6.638,0c-.4,0-.8,0-1.195,0-.361,0-.506-.148-.506-.513q0-4.957,0-9.914c0-.364.147-.505.511-.506h5.753",
    transform: "translate(-69.51 -99.019)",
    fill: "#d1d0cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16124",
    "data-name": "Path 16124",
    d: "M161.328,40.657c-.589,0-1.178,0-1.767,0-.148,0-.205-.035-.207-.2-.005-.6-.011-.6.592-.6,1.038,0,2.076,0,3.114,0,.177,0,.243.039.24.23-.008.57,0,.57-.559.57h-1.414",
    transform: "translate(-152.829 -37.906)",
    fill: "#d1d0d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16125",
    "data-name": "Path 16125",
    d: "M176.813,72.328c-.324,0-.648-.005-.971,0-.139,0-.2-.035-.193-.185a3.3,3.3,0,0,0,0-.441c-.009-.139.051-.175.181-.175.662,0,1.324.006,1.987,0,.153,0,.181.06.183.2.008.6.012.6-.59.6h-.6",
    transform: "translate(-168.325 -68.029)",
    fill: "#d1d0d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16126",
    "data-name": "Path 16126",
    d: "M80.964,350.938c.324,0,.648.005.971,0,.138,0,.193.032.2.183.013.616.018.615-.6.615-.515,0-1.03,0-1.545,0-.146,0-.206-.032-.208-.194-.006-.6-.012-.6.59-.6h.6",
    transform: "translate(-77.148 -333.755)",
    fill: "#d1d0d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16127",
    "data-name": "Path 16127",
    d: "M93.349,121.042c-1.732,0-3.465,0-5.2,0-.19,0-.259-.042-.251-.243.016-.383.01-.767,0-1.15,0-.148.034-.207.2-.207q5.275.006,10.549,0c.165,0,.2.065.193.209-.007.391-.013.782,0,1.172.007.186-.066.218-.231.217q-2.632-.007-5.264,0",
    transform: "translate(-84.873 -113.599)",
    fill: "#ededed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16128",
    "data-name": "Path 16128",
    d: "M138.577,168.16c-.833,0-1.665-.006-2.5,0-.189,0-.234-.059-.232-.239.007-.562,0-.562.568-.562,1.54,0,3.08,0,4.62,0,.189,0,.273.03.267.249-.015.55,0,.551-.559.551h-2.166",
    transform: "translate(-130.473 -159.169)",
    fill: "#ededed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16129",
    "data-name": "Path 16129",
    d: "M138.572,232.321c-.833,0-1.665-.005-2.5,0-.18,0-.223-.056-.222-.227,0-.574,0-.574.578-.574,1.54,0,3.08,0,4.62,0,.208,0,.26.061.256.261-.012.54,0,.54-.546.54h-2.188",
    transform: "translate(-130.478 -220.186)",
    fill: "#ededed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16130",
    "data-name": "Path 16130",
    d: "M138.572,263.977c-.833,0-1.665-.005-2.5,0-.18,0-.223-.056-.221-.227,0-.573,0-.573.578-.573,1.54,0,3.08,0,4.62,0,.208,0,.26.061.255.261-.012.54,0,.54-.546.54Z",
    transform: "translate(-130.478 -250.293)",
    fill: "#ededed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16131",
    "data-name": "Path 16131",
    d: "M138.563,200.643c-.833,0-1.666,0-2.5,0-.169,0-.23-.039-.228-.22.006-.537,0-.537.527-.537,1.562,0,3.125,0,4.687,0,.179,0,.243.042.24.231-.008.526,0,.526-.516.526h-2.211",
    transform: "translate(-130.462 -190.102)",
    fill: "#ededed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16132",
    "data-name": "Path 16132",
    d: "M138.586,296.469c-.84,0-1.68,0-2.52,0-.167,0-.212-.051-.211-.214,0-.543,0-.543.543-.543,1.555,0,3.11,0,4.665,0,.2,0,.25.055.245.249-.011.509,0,.51-.51.51h-2.211",
    transform: "translate(-130.479 -281.236)",
    fill: "#ededed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16133",
    "data-name": "Path 16133",
    d: "M264.541,168.2c-.331,0-.662,0-.993,0-.121,0-.176-.035-.17-.163.008-.162.007-.324,0-.485,0-.119.05-.151.159-.151q1.015,0,2.031,0c.11,0,.152.035.16.151.042.646.045.646-.591.646h-.6",
    transform: "translate(-251.76 -159.211)",
    fill: "#ededed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16134",
    "data-name": "Path 16134",
    d: "M264.252,231.583c.331,0,.662,0,.993,0,.121,0,.175.036.17.163-.007.162-.007.324,0,.486,0,.119-.051.151-.16.15q-1.015,0-2.031,0c-.111,0-.152-.036-.159-.152-.042-.646-.045-.646.591-.646h.6",
    transform: "translate(-251.447 -220.246)",
    fill: "#ededed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16135",
    "data-name": "Path 16135",
    d: "M264.495,263.988c-.331,0-.662-.006-.993,0-.147,0-.185-.051-.188-.192-.01-.607-.014-.607.586-.607.515,0,1.03.008,1.545,0,.179,0,.223.056.221.226,0,.574,0,.574-.576.574h-.6",
    transform: "translate(-251.697 -250.305)",
    fill: "#ededed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16136",
    "data-name": "Path 16136",
    d: "M264.529,327.4c.324,0,.648.006.971,0,.146,0,.186.048.189.191.01.608.014.608-.585.608-.522,0-1.045-.005-1.567,0-.156,0-.2-.05-.2-.2,0-.6-.009-.6.6-.6h.6",
    transform: "translate(-251.721 -311.374)",
    fill: "#ededed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16137",
    "data-name": "Path 16137",
    d: "M264.507,200.665c-.324,0-.648-.006-.972,0-.149,0-.2-.037-.206-.2,0-.56-.01-.56.547-.56.537,0,1.075,0,1.612,0,.14,0,.192.036.194.185.011.571.016.571-.557.571h-.618",
    transform: "translate(-251.714 -190.123)",
    fill: "#ededed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16138",
    "data-name": "Path 16138",
    d: "M264.517,295.77c.331,0,.663,0,.994,0,.12,0,.166.035.172.162.029.593.032.593-.557.593-.53,0-1.06,0-1.59,0-.149,0-.2-.037-.206-.2,0-.56-.01-.56.547-.56h.64",
    transform: "translate(-251.714 -281.29)",
    fill: "#ededed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16139",
    "data-name": "Path 16139",
    d: "M88.646,167.416c.206,0,.412,0,.618,0,.1,0,.147.038.145.142,0,.169-.006.338,0,.507,0,.12-.053.15-.161.149q-.618,0-1.235,0c-.112,0-.167-.038-.155-.154a.159.159,0,0,0,0-.022c-.026-.622-.026-.622.59-.622h.2",
    transform: "translate(-84.825 -159.219)",
    fill: "#ededed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16140",
    "data-name": "Path 16140",
    d: "M88.691,232.366c-.2,0-.4-.008-.6,0-.149.008-.184-.052-.187-.192-.009-.606-.014-.606.586-.606.257,0,.515.005.772,0,.135,0,.195.028.2.181.014.618.019.617-.6.617h-.176",
    transform: "translate(-84.88 -220.232)",
    fill: "#ededed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16141",
    "data-name": "Path 16141",
    d: "M88.736,264.048c-.2,0-.4,0-.6,0-.12,0-.176-.034-.17-.163.007-.161.007-.324,0-.485,0-.118.048-.152.158-.151q.617.005,1.235,0c.11,0,.152.035.16.151.043.647.046.646-.59.646h-.2",
    transform: "translate(-84.94 -250.365)",
    fill: "#ededec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16142",
    "data-name": "Path 16142",
    d: "M88.645,200.566c-.2,0-.4-.007-.6,0-.138.006-.173-.049-.176-.18-.015-.576-.019-.576.551-.575.28,0,.561-.02.838.005.331.031.119.3.153.451.023.1.1.3-.152.3-.206,0-.412,0-.618,0",
    transform: "translate(-84.843 -190.025)",
    fill: "#ededed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16143",
    "data-name": "Path 16143",
    d: "M88.582,295.778c.206,0,.412,0,.618,0,.115,0,.149.044.155.156.036.6.039.6-.549.6-.28,0-.559,0-.839,0-.125,0-.162-.045-.167-.167-.025-.588-.028-.588.561-.588h.221",
    transform: "translate(-84.77 -281.298)",
    fill: "#ededed"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyAccountBets);
export default __webpack_public_path__ + "static/media/my-account-bets.788b13d827bb123ac576f427159df040.svg";
export { ForwardRef as ReactComponent };